(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sd-hx-organization-web"] = factory();
	else
		root["sd-hx-organization-web"] = factory();
})(self, function() {
return 